import { render, staticRenderFns } from "./AddOtherPartner.vue?vue&type=template&id=7ab34d3f&"
import script from "./AddOtherPartner.vue?vue&type=script&lang=js&"
export * from "./AddOtherPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/blocks/AddOtherPartner.vue
// module id = null
// module chunks = 